const GET_ALL_SELECTED_CRITERIA = 'getAllSelectedCriteria';

export default GET_ALL_SELECTED_CRITERIA;
